import { BrowserRouter } from "react-router-dom";
import Home from "./pages/Home";
import "./styles/styles.css";

function App() {
  return (
    <BrowserRouter>
      <Home />
    </BrowserRouter>
  );
}

export default App;
